var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKeyBackPrimary500(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#E4E1FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_69_10453",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_69_10453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 30C17.3333 30 15.9167 29.4167 14.75 28.25C13.5833 27.0833 13 25.6667 13 24C13 22.3333 13.5833 20.9167 14.75 19.75C15.9167 18.5833 17.3333 18 19 18C20.1 18 21.1083 18.275 22.025 18.825C22.9417 19.375 23.6667 20.1 24.2 21H35V27H33V30H27V27H24.2C23.6667 27.9 22.9417 28.625 22.025 29.175C21.1083 29.725 20.1 30 19 30ZM19 28C20.1 28 20.9833 27.6625 21.65 26.9875C22.3167 26.3125 22.7167 25.65 22.85 25H29V28H31V25H33V23H22.85C22.7167 22.35 22.3167 21.6875 21.65 21.0125C20.9833 20.3375 20.1 20 19 20C17.9 20 16.9583 20.3917 16.175 21.175C15.3917 21.9583 15 22.9 15 24C15 25.1 15.3917 26.0417 16.175 26.825C16.9583 27.6083 17.9 28 19 28ZM19 26C19.55 26 20.0208 25.8042 20.4125 25.4125C20.8042 25.0208 21 24.55 21 24C21 23.45 20.8042 22.9792 20.4125 22.5875C20.0208 22.1958 19.55 22 19 22C18.45 22 17.9792 22.1958 17.5875 22.5875C17.1958 22.9792 17 23.45 17 24C17 24.55 17.1958 25.0208 17.5875 25.4125C17.9792 25.8042 18.45 26 19 26Z",
    fill: "#766AFF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyBackPrimary500);
export default __webpack_public_path__ + "static/media/key-back-primary-500.35a1986f872aa8086e2ec04a8c56882b.svg";
export { ForwardRef as ReactComponent };